import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	panelSplitter: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	panelSplitter: {
		id: 'platform-conversation-assistant.panelSplitter.label',
		defaultMessage: 'Resize panel',
		description: 'label text for a button that will allow resizing of the right side panel',
	},
});
export default messages;
